// src/lib/boardConfig.ts
import type { TaskStatus } from "../types/domain";

export type ColumnConfig = {
  key: TaskStatus;
  name: string;     // título visible
  visible: boolean; // mostrar/ocultar
};

const DEFAULT: ColumnConfig[] = [
  { key: "todo",         name: "To do",       visible: true },
  { key: "in_progress",  name: "In progress", visible: true },
  { key: "in_review",    name: "In review",   visible: true },
  { key: "done",         name: "Done",        visible: true },
  { key: "backlog",      name: "Backlog",     visible: false },
  { key: "archived",     name: "Archivadas/Eliminadas",    visible: false },
];

function keyFor(projectId?: string) {
  return `board:columns:${projectId ?? "default"}`;
}

export function loadBoardConfig(projectId?: string): ColumnConfig[] {
  try {
    const raw = localStorage.getItem(keyFor(projectId));
    if (!raw) return DEFAULT.slice();
    const parsed = JSON.parse(raw) as ColumnConfig[];
    // sanity: que existan todas las keys conocidas
    const map = new Map(parsed.map((c) => [c.key, c]));
    const merged = DEFAULT.map((d) => map.get(d.key) ?? d);
    // y añadimos cualquiera extra (por si venía de otra versión)
    parsed.forEach((c) => { if (!merged.find((m) => m.key === c.key)) merged.push(c); });
    return merged;
  } catch {
    return DEFAULT.slice();
  }
}

export function saveBoardConfig(projectId: string | undefined, conf: ColumnConfig[]) {
  localStorage.setItem(keyFor(projectId), JSON.stringify(conf));
}

export function resetBoardConfig(projectId?: string) {
  localStorage.removeItem(keyFor(projectId));
}
